import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import CreateForm from "./CreateForm";

const CreateItemGroup = () => {
  return (
    <>
      <div className="d-flex flex-column" style={{ height: '100vh' }}>
      <Helmet>
				<title>Item Group - Create</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <CreateForm />
      </div>
      </div>
    </>
  );
};

export default CreateItemGroup;
